import { http } from '@/lib/axios'

import type { Customize } from '@/types/settings'

export const fetchSettingsService = async () => {
  const { data } = await http.get<{ data: Customize }>('configuracoes')

  return data
}
